  import * as ActionTypes from "../Types/ActionTypes";

  export const ExpensesMain = (
    state = {
      isLoading: false,
      expensesState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.EXPENSES_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.EXPENSES:
        return {
          ...state,
          isLoading: false,
          expensesState: action.payload,
        };

      case ActionTypes.EXPENSES_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
